import { theme as cgx } from "./cgx";
import { theme as mx } from "./mx";
export var theme = { cgx: cgx, mx: mx };
